import React, { useCallback } from 'react';
import { BaseTable } from '@/components';
import { useUserManagementTable } from '@/components/pages/SettingsPage/MainContent/UserManagement/useUserManagement';
import { BaseButton } from '@/components/uiKit/Button';
import { Skeleton } from '@/components/ui/skeleton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const UserManagement = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tableStructure, tableData, isLoadingUsersData, isFetchingUsersData } = useUserManagementTable();

  const handleNavigateToCreateUser = useCallback(() => {
    navigate('create');
  }, [navigate]);

  return (
    <div className="flex flex-col h-full gap-4">
      <div className="flex flex-row w-full justify-end gap-4">
        <BaseButton variant="filled" size="xl" onClick={handleNavigateToCreateUser}>
          {t('userManagement.createUser')}
        </BaseButton>
      </div>

      {isLoadingUsersData || isFetchingUsersData ? (
        <Skeleton className="w-full min-h-fit" />
      ) : (
        <BaseTable
          data={tableData}
          columns={tableStructure}
          wrapHeaders={false}
          classNames={{
            card: {
              container: 'h-full w-full overflow-x-auto max-h-full max-w-[calc(100%)] overflow-x-auto rounded-lg',
              content: 'p-0 m-2 overflow-y-hidden max-h-full ',
            },
            table: {
              container:
                'overflow-auto h-full w-full sticky top-0  min-h-[calc(100vh-15.8rem)] max-h-[calc(100vh-15.8rem)]',
              th: '[&>*]:text-left [&>*]:text-subtext [&>*]:font-medium [&>*]:text-[14px] py-2',
              tr: 'h-14 bg-white ',
              td: 'group-hover:bg-gray-100 text-[14px] [&>*]:text-[12px]',
            },
          }}
        />
      )}
    </div>
  );
};
